import * as React from 'react'

import { cn } from '@repo/ui/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        `border-input bg-input-background selection:bg-primary selection:text-primary-foreground file:text-foreground placeholder:text-muted-foreground hover:border-ring dark:bg-input/30 flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base outline-none transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm`,
        `focus-visible:border-ring focus-visible:ring-ring/20 focus-visible:ring-[1px]`,
        `aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40`,
        className,
      )}
      {...props}
    />
  )
}

export { Input }
